import { takeLatest, all, takeEvery } from 'redux-saga/effects';
import getConfig from './settings';
import {
  receiveToken,
  loginNossaUser,
  isAuthenticated,
  logoutUser,
  receiveUser,
  receiveUserNossa,
} from './user';
import { setStep } from './steps';
import { setProperties, sendPageview, sendCustomEvent, resetUserMetrics, sendKMSet, sendPurchaseMetrics, sendKMIdentify, sendGA4Metrics, sendActionEvent } from './metrics';

export default function* rootSaga() {
  yield all([
    takeLatest('FETCH_CONFIG', getConfig),
    takeLatest('LOGIN_NOSSA_USER', loginNossaUser),
    takeLatest('RECEIVE_TOKEN', receiveToken),
    takeLatest('IS_AUTHENTICATED', isAuthenticated),
    takeLatest('LOGOUT_USER', logoutUser),
    takeLatest('RECEIVE_USER', receiveUser),
    takeLatest('RECEIVE_USER_NOSSA', receiveUserNossa),
    takeLatest('SET_STEP', setStep),
    takeEvery('SET_METRICS_PROPERTIES', setProperties),
    takeEvery('SEND_PAGEVIEW', sendPageview),
    takeEvery('SEND_CUSTOM_EVENT', sendCustomEvent),
    takeEvery('SEND_KM_SET', sendKMSet),
    takeEvery('SEND_KM_IDENTIFY', sendKMIdentify),
    takeEvery('SEND_GA4_METRICS', sendGA4Metrics),
    takeEvery('RESET_USER_METRICS', resetUserMetrics),
    takeLatest('SAVE_PURCHASE', sendPurchaseMetrics),
    takeEvery('SEND_ACTION_EVENT', sendActionEvent),
  ]);
}
